import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ApplicationSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = "Application Submitted - IP Partners Inc";
    // Simulate loading
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brown-700 mx-auto"></div>
          <p className="mt-4 text-brown-700">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-brown-50 to-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-green-100 rounded-full p-4">
              <CheckCircle className="w-16 h-16 text-green-600" />
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold text-brown-900 mb-4">
            Thank You for Contacting Us!
          </h1>

          <p className="text-lg text-brown-700 mb-6">
            Your request has been successfully submitted.
          </p>

          {customerId && (
            <div className="bg-brown-50 rounded-lg p-6 mb-6">
              <p className="text-sm text-brown-600 mb-1">Your Reference ID:</p>
              <p className="text-2xl font-bold text-brown-900">#{customerId}</p>
              <p className="text-sm text-brown-600 mt-2">
                Please save this reference number for future correspondence.
              </p>
            </div>
          )}

          <div className="space-y-4 text-left mb-8">
            <div className="border-l-4 border-brown-600 pl-4">
              <h3 className="font-semibold text-brown-900 mb-1">What's Next?</h3>
              <p className="text-brown-700">
                One of our experienced attorneys will review your case and contact you within 24 business hours.
              </p>
            </div>

            <div className="border-l-4 border-brown-600 pl-4">
              <h3 className="font-semibold text-brown-900 mb-1">Check Your Email</h3>
              <p className="text-brown-700">
                We've sent a confirmation email with your case details and next steps.
              </p>
            </div>

            <div className="border-l-4 border-brown-600 pl-4">
              <h3 className="font-semibold text-brown-900 mb-1">Urgent Matter?</h3>
              <p className="text-brown-700">
                For urgent legal matters, please call us directly at{' '}
                <a href="tel:+18332017574" className="font-semibold text-brown-800 hover:underline">
                  +1 (833) 201-7574
                </a>
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="bg-brown-700 text-white px-8 py-3 rounded-lg font-medium hover:bg-brown-800 transition-colors duration-200"
            >
              Back to Home
            </a>
            <a
              href="/services/corporate-business-contracts"
              className="bg-white text-brown-700 px-8 py-3 rounded-lg font-medium border-2 border-brown-700 hover:bg-brown-50 transition-colors duration-200"
            >
              Explore Our Services
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSuccessPage;
